import React from 'react';

type BadgeVariant = 'active' | 'memorial' | 'private' | 'founding' | 'premium' | 'free' | 'pending' | 'approved' | 'rejected' | 'suspended' | 'warning';

const VARIANTS: Record<BadgeVariant, string> = {
  active: 'bg-green-50 text-green-700 border-green-200',
  memorial: 'bg-purple-50 text-purple-700 border-purple-200',
  private: 'bg-gray-50 text-gray-600 border-gray-200',
  founding: 'bg-amber-50 text-amber-700 border-amber-200',
  premium: 'bg-primary/10 text-primary border-primary/20',
  free: 'bg-muted text-muted-foreground border-border',
  pending: 'bg-yellow-50 text-yellow-700 border-yellow-200',
  approved: 'bg-green-50 text-green-700 border-green-200',
  rejected: 'bg-red-50 text-red-700 border-red-200',
  suspended: 'bg-red-50 text-red-700 border-red-200',
  warning: 'bg-orange-50 text-orange-700 border-orange-200',
};

export default function StatusBadge({ variant, label }: { variant: BadgeVariant; label: string }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-600 border ${VARIANTS[variant]}`}>
      {label}
    </span>
  );
}